import { Component, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl } from '../common/base-list.component';
import { ServiceLocatorService } from '../common/service/service-locator.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { GlobalConstants } from '../common/GlobalConstants ';

@Component({
  selector: 'app-appointment-list',
  templateUrl: './appointment-list.component.html',
  styleUrls: ['./appointment-list.component.css']
})
export class AppointmentListComponent extends BaseListCtl {
  departList = null;
  departGateList = null;
  departUnitList = null;
  departmentList = null;
  dID = 0;
  eID = 0;
  datePickerConfig: Partial<BsDatepickerConfig>;
  //userContext = this.locator.userContext;

  login = localStorage.getItem('loginId');
 // userContext = JSON.parse(localStorage.getItem('userContext'));
 userContext = JSON.parse(localStorage.getItem(GlobalConstants.getKey('userContext')));
  timed = new Date();

  get getTime() {
    return this.timed;
  }

  constructor(public locator: ServiceLocatorService, public route: ActivatedRoute, zone: NgZone) {
    super(locator.endpoints.APPOINTMENT, locator, route);

    this.datePickerConfig = Object.assign({},
      {
        containerClass: 'theme-dark-blue',
        showWeekNumbers: true,

        dateInputFormat: 'DD-MM-YYYY'
      });


  }

 // userContext  = localStorage.getItem('userContext');

  populateForm(form, data) {
    form.name = data.name;
    form.id = data.id;
    form.date = data.date;
    form.startTime = data.startTime;
    form.endTime = data.endTime;
    form.start = data.start;
    form.end = data.end;
    form.unitId = data.unitId;
    form.unitName = data.unitName;
    form.gateId = data.gateId;
    form.gateName = data.gateName;
    form.visitorId = data.visitorId;
    form.visitorName = data.visitorName;
    form.employeeId = data.employeeId;
    form.employeeName = data.employeeName;
    form.approverId = data.approverId;
    form.approverName = data.approverName = this.userContext.name;
    form.approverDateTime = data.approverDateTime = this.getTime;
    form.status = data.status;
    form.userId = data.userId;
    form.userName = data.userName;
    form.departmentId = data.departmentId;
    form.departmentName = data.departmentName;
    form.remark = data.remark;
    //this.allList(form.departmentId);
  }

  preloadByDepartment(dID) {
    console.log("======preloadByDepartment========");
    if (dID != null && dID >= 0) {

      var _self = this;
      _self.departList = null;
      //_self.form.data["employeeId"] == null;
      var searchParam = { "departmentId": dID }
      let officerUrl = this.locator.endpoints.getEndpoint(this.locator.endpoints.APPOINTMENT, "/preloadByDepartment/" + dID);
      console.log(_self.endpoint, " Search Form ", searchParam);
      this.locator.http.get(officerUrl, function (res, error) {

        if (res.success) {
          _self.departList = res.result.officerList;
          _self.form.data["unitId"] = res.result.unitId;
          _self.form.data["gateId"] = res.result.gateId;
          _self.form.data["unitName"] = res.result.unitName;
          _self.form.data["gateName"] = res.result.gateName;
          console.log("List Size", _self.departList);
        }

      });

    }
  }

  preloadByEmployee(eID) {
    var _self = this;
    if (eID != null && eID > 0) {

      var _self = this;
      _self.departList = null;
      var searchParam = { "employeeId": eID }
      let Url = this.locator.endpoints.getEndpoint(this.locator.endpoints.APPOINTMENT, "/preloadByEmployee/" + eID);
      console.log(_self.endpoint, " Search Form ", searchParam);
      this.locator.http.get(Url, function (res, error) {

        if (res.success) {
          console.log("==officerList=" + res.result.officerList);
          console.log("==departmentList=" + res.result.departmentList);

          _self.form.preload["departmentList"] = res.result.departmentList;
          _self.departList = res.result.officerList;

          _self.form.data["id"] = res.result.id;
          _self.form.data["name"] = res.result.name;

        }
      });
    }
  }

  getEditPermission(id) {
    console.log("--------------------getEditPermission------------",)
    this.get(id);
    this.disable();
  }

  parseDate(dateString: string): Date {
    if (dateString) {
      return new Date(dateString);
    }
    return null;
  }
  private todate = new Date();

  permissionButton(status) {
    if (status == 'Accept') {
      var _self = this;
      _self.form.data["status"] = status;
      this.save();
    }
    if (status == 'Reject') {
      var _self = this;
      _self.form.data["status"] = status;
      this.save();
    }
    if (status == 'Complete') {
      var _self = this;
      _self.form.data["status"] = status;
      this.save();
    }
    if (status == 'Not Visited') {
      var _self = this;
      _self.form.data["status"] = status;
      this.save();
    }

  }

  /**
   * Reset form
   */
  resetForm() {

    console.log("inside reset");

    var _self = this;
    this.form.error = false;
    this.form.message = "";
    this.form.data = { id: null, };
    _self.form.data["employeeId"] = null;
    _self.form.data["departmentId"] = null;
    _self.form.data["gateId"] = null;
    _self.form.data["unitId"] = null;

    this.form.inputerror = {};
  }

}
